import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { trustedByPartners } from '../../constants/content';
import PartnersSlider from '../ui/PartnersSlider';
import { useSectionView } from '../../hooks/useSectionView';

export default function TrustedBy() {
  const { t } = useTranslation();
  const { darkMode } = useTheme();
  const sectionRef = useSectionView('trusted_by', 1);

  return (
    <section
      ref={sectionRef}
      id="trusted-by"
      className={`py-16 ${darkMode ? 'bg-main-black' : 'bg-white'}`}
    >
      <div className="max-w-[1600px] mx-auto">
        {/* Headline */}
        <h2 className={`titleFont text-3xl md:text-4xl font-bold text-center mb-4 px-5 ${
          darkMode ? 'text-white' : 'text-gray-900'
        }`}>
          {t('trustedBy.headline')}
        </h2>

        {/* Subtext */}
        <p className={`text-center mb-10 max-w-2xl mx-auto px-5 ${
          darkMode ? 'text-gray-400' : 'text-gray-600'
        }`}>
          {t('trustedBy.subtext')}
        </p>

        {/* Partner logos slider */}
        <PartnersSlider partners={trustedByPartners} />
      </div>
    </section>
  );
}
